document.addEventListener('DOMContentLoaded', function() {
  console.log("JavaScript per la validazione della password caricato correttamente!");

  // Controlla se sei nella pagina di registrazione o di reimpostazione della password
  var passwordField = document.getElementById('CreatePassword') || document.getElementById('ResetPassword');
  var lengthCriteria = document.getElementById('length') || document.getElementById('length-reset');
  var uppercaseCriteria = document.getElementById('uppercase') || document.getElementById('uppercase-reset');
  var lowercaseCriteria = document.getElementById('lowercase') || document.getElementById('lowercase-reset');
  var numberCriteria = document.getElementById('number') || document.getElementById('number-reset');
  var specialCriteria = document.getElementById('special') || document.getElementById('special-reset');
  var togglePasswordIcon = document.getElementById('eyeIcon') || document.getElementById('resetEyeIcon');

  // Verifica se il campo password è stato trovato
  if (!passwordField) {
    console.log("Errore: Campo password non trovato!");
    return;
  }

  // Funzionalità di Mostra/Nascondi Password
  togglePasswordIcon.addEventListener('click', function() {
    var type = passwordField.getAttribute('type') === 'password' ? 'text' : 'password';
    passwordField.setAttribute('type', type);

    // Cambia l'icona tra occhio aperto e chiuso
    if (type === 'text') {
      togglePasswordIcon.classList.remove('fa-eye-slash');
      togglePasswordIcon.classList.add('fa-eye');
    } else {
      togglePasswordIcon.classList.remove('fa-eye');
      togglePasswordIcon.classList.add('fa-eye-slash');
    }
  });

  // Aggiungi l'evento 'input' per la validazione della password
  passwordField.addEventListener('input', function() {
    var password = passwordField.value;

    // Controlla la lunghezza della password
    if (password.length >= 12) {
      lengthCriteria.classList.add('valid');
    } else {
      lengthCriteria.classList.remove('valid');
    }

    // Controlla se c'è almeno una lettera maiuscola
    if (/[A-Z]/.test(password)) {
      uppercaseCriteria.classList.add('valid');
    } else {
      uppercaseCriteria.classList.remove('valid');
    }

    // Controlla se c'è almeno una lettera minuscola
    if (/[a-z]/.test(password)) {
      lowercaseCriteria.classList.add('valid');
    } else {
      lowercaseCriteria.classList.remove('valid');
    }

    // Controlla se c'è almeno un numero
    if (/[0-9]/.test(password)) {
      numberCriteria.classList.add('valid');
    } else {
      numberCriteria.classList.remove('valid');
    }

    // Controlla se c'è almeno un carattere speciale
    if (/[!@#$%^&*]/.test(password)) {
      specialCriteria.classList.add('valid');
    } else {
      specialCriteria.classList.remove('valid');
    }
  });
});
